<template>
    <div class="wrapper">
        <b-container style="background: #f3f1f2">
            <b-row>
                <b-col cols="" md="3"></b-col>
                <b-col cols="12" md="9" style="background: #fff">
                    <b-row ><h1 class="tit font-color mt-4 ml-5">{{ $i18n.locale=='en' ? '': info.awardYear}} {{info.awardName}} {{personType(info.type)}}</h1></b-row>
                </b-col>
                <b-col cols="6" md="3" class="layout">
                    <b-row>
                        <div class="img-wrap img-hovor">
                            <img
                                width="100%"
                                height="100%"
                                :src="info.photoUrl"
                            />
                        </div>
                    </b-row>
                    <b-row clos="12" class="font-color mt-2 ml-4 mr-4">{{info.summary}}</b-row>
                    <b-row>
                        <div class="img-wrap img-hovor">
                            <viewer :images="photo" :options="{toolbar: false, title: false, navbar: false}"> 
                                <img width="100%" 
                                    v-for="(src, index) in photo"
                                    :src="src"
                                    :key="index"
                                >
                            </viewer>
                        </div>
                    </b-row>
                </b-col>
                <!-- < 768px -->
                <b-col cols="12"  class="min-layout">
                     <b-row cols="12" >
                        <b-col  align-self="end"  cols="6">
                            <div class="img-wrap img-hovor">
                                <img
                                    width="100%"
                                    height="100%"
                                    :src="info.photoUrl"
                                />
                            </div>
                        </b-col>
                        <div style="align-self: flex-end; margin-bottom: 4rem;">
                            <div class="tit-name">{{info.donorName}}</div>
                            <div class="tit-enname">{{info.donorEnName}}</div>
                        </div>
                    </b-row>
                    <b-row clos="12" class="director ml-4 mr-4">{{info.rank}}</b-row>
                    <b-row clos="12" class="director intro1 ml-4 mr-4">{{info.summary}}</b-row>
                    <b-row>
                        <div class="img-wrap img-hovor">
                            <viewer :images="photo" :options="{toolbar: false, title: false, navbar: false}"> 
                                <img width="100%" 
                                    v-for="(src, index) in photo"
                                    :src="src"
                                    :key="index"
                                >
                            </viewer>
                        </div>
                    </b-row>
                </b-col>
               
                <b-col clos="12" md="9" style="background: #fff">
                    <b-row clos="6" class="layout pl-5  pr-5 pt-4">
                        <b-col>
                            <b-row class="tit-name">{{info.donorName}}</b-row>
                            <b-row class="tit-enname">{{info.donorEnName}}</b-row>
                        </b-col>
                    </b-row>
                    <b-row clos="12" class="pl-5 pr-5 pt-4">
                        <div class="detail" v-html="info.detailedIntroduction"></div>
                    </b-row>
                            <!-- 展示区 -->
                    <layoutimg v-if="videoList.length!==0" type="donorVideo" :dornorID="$route.query.id"  height="8rem" :cols="6" :md="4"  :dataList="videoList" ></layoutimg>                             
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import 'viewerjs/dist/viewer.css';
import Viewer from "v-viewer/src/component.vue";
export default {
    components:{
        Viewer
    },
    data(){
        return{
            info:{},
            show: false,
            photo: [],
            videoList: []
        }
    },
    created(){
        this.getCharacterInfo(this.$route.query.id)
        this.getDetailRelatedVideo(this.$route.query.id)
    },
    methods:{
        getDetailRelatedVideo(donorId){
            this.$api.detailRelatedVideo({
                donorId: donorId,
                page: 1,
                limit: 20
            }).then(res=>{
                this.videoList = res.data.records
            })
        },
        clickImg(){
            this.show = true
        },
        getCharacterInfo(id){
            this.$api.characterInfo({
                id : id
            })
            .then(res=>{
                this.info = res.data
                this.photo = [res.data.certificateUrl]
            })
        },
        personType(type){
            if(type =='1'){
                return this.$t('lang.detialLaureates')
            }else if(type == '2'){
                return this.$t('lang.detialDondor')
            }
        }
    }
}
</script>
<style lang="scss" scoped>

 .wrapper::v-deep{
     .viewer-close {
            background-color: rgba(153, 153, 153, 0.8);
        }
 } 
.layout{
    display: none;
}

.min-layout{
    display: block;
    background: #fff;
}
 .detail{
        color: #969494;
        font-size: 1.2rem;
        line-height: 2.5rem;
    }
.director{
    color: #666666;
    font-size: 1.2rem;
}
.intro1{
    margin-top: 1rem;
}
.wrapper{
    
    .img-wrap{
        width: 85%;
        margin: 2rem;
    }
     .tit{
        font-size: 1.6rem !important;
        font-weight: normal !important;
    }
    .tit-name{
        color: #666666;
        font-weight: bold;
        font-size: 1.6rem;
    }
    .tit-enname{
        color: #666666;
        font-size: 1.5rem;
    }
}
@media (min-width: 768px) {
    .layout{
        display: block;
    }
    .min-layout{
        display: none;
    }
   
    .tit-name{
        margin-top: 1rem;
        color: #666666;
        font-weight: bold;
        font-size: 1.8rem;
    }
    .tit-enname{
        color: #666666;
        font-size: 1.5rem;
    }
   
    
}
</style>